import { useState, useEffect } from "react";
import { Home, FileCode2, Gavel, Loader2 } from "lucide-react";
import axios from "axios";
import { getApiUrl } from "@/utils/api";

const API = getApiUrl();

const MODULES = [
  { key: "house_prices", label: "House Prices", icon: Home, color: "text-blue-600 bg-blue-100" },
  { key: "planning_applications", label: "Planning Applications", icon: FileCode2, color: "text-amber-600 bg-amber-100" },
  { key: "planning_appeals", label: "Planning Appeals", icon: Gavel, color: "text-rose-600 bg-rose-100" },
];

export default function ToolSearchStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/admin/tool-search-stats`, { withCredentials: true })
      .then(({ data }) => setStats(data.modules || {}))
      .catch(() => setStats({}))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="bg-white border border-border p-6 rounded-lg flex justify-center" data-testid="tool-search-stats-loading">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="bg-white border border-border p-5 rounded-lg" data-testid="tool-search-stats">
      <h3 className="font-serif text-base font-medium mb-1">Public Tool Searches</h3>
      <p className="text-xs text-muted-foreground mb-4">House Prices, Planning Applications &amp; Appeals lookups on your public site (all searches, including cached results).</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wide text-muted-foreground">
              <th className="py-2 pr-4">Tool</th>
              <th className="py-2 px-3 text-right">Today</th>
              <th className="py-2 px-3 text-right">This Week</th>
              <th className="py-2 px-3 text-right">This Month</th>
            </tr>
          </thead>
          <tbody>
            {MODULES.map(({ key, label, icon: Icon, color }) => {
              const s = stats?.[key] || { today: 0, week: 0, month: 0 };
              return (
                <tr key={key} className="border-t border-border" data-testid={`tool-search-stats-row-${key}`}>
                  <td className="py-3 pr-4">
                    <div className="flex items-center gap-2">
                      <span className={`p-1.5 rounded-md ${color}`}><Icon className="h-3.5 w-3.5" /></span>
                      <span className="font-medium">{label}</span>
                    </div>
                  </td>
                  <td className="py-3 px-3 text-right font-semibold" data-testid={`tool-search-stats-${key}-today`}>{s.today.toLocaleString()}</td>
                  <td className="py-3 px-3 text-right" data-testid={`tool-search-stats-${key}-week`}>{s.week.toLocaleString()}</td>
                  <td className="py-3 px-3 text-right" data-testid={`tool-search-stats-${key}-month`}>{s.month.toLocaleString()}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
